import IndexedDBHelper from '@/utils/indexDB';
import { BaseImageStatus } from '../layoutContext/ImageProcessingContext';

// 创建专门的图像处理IndexDB实例
const imageProcessingDB = new IndexedDBHelper(
  'imageProcessing',
  'imageCache',
  1
);

export const imageIndexDB = {
  // 保存单个图像数据
  async saveImage<T extends BaseImageStatus>(
    id: string,
    imageStatus: T
  ): Promise<void> {
    try {
      await imageProcessingDB.storeData(id, imageStatus);
    } catch (error) {
      console.error('Failed to save image to IndexDB:', error);
    }
  },

  // 获取单个图像数据
  async getImage<T extends BaseImageStatus>(id: string): Promise<T | null> {
    try {
      return await imageProcessingDB.getData<T>(id);
    } catch (error) {
      console.error('Failed to get image from IndexDB:', error);
      return null;
    }
  },

  // 获取所有图像数据
  async getAllImages<T extends BaseImageStatus>(): Promise<Map<string, T>> {
    try {
      const db = await imageProcessingDB.openDatabase();
      const transaction = db.transaction('imageCache', 'readonly');
      const store = transaction.objectStore('imageCache');

      return new Promise((resolve) => {
        const request = store.getAll();
        request.onsuccess = () => {
          const images = new Map<string, T>();
          request.result.forEach((item: { id: string; data: T }) => {
            images.set(item.id, item.data);
          });
          resolve(images);
        };
      });
    } catch (error) {
      console.error('Failed to get all images from IndexDB:', error);
      return new Map();
    }
  },

  // 删除单个图像数据
  async removeImage(id: string): Promise<void> {
    try {
      await imageProcessingDB.deleteData(id);
    } catch (error) {
      console.error('Failed to remove image from IndexDB:', error);
    }
  },

  // 清空所有图像数据
  async clearImages(): Promise<void> {
    try {
      await imageProcessingDB.clearAllData();
    } catch (error) {
      console.error('Failed to clear images from IndexDB:', error);
    }
  },
};
